// Slot-machine style sound effects, synthesised in the browser (no files, works offline).
const KEY = "gl_sound_muted";
let ctx = null;

export const isMuted = () => localStorage.getItem(KEY) === "1";
export const setMuted = (m) => localStorage.setItem(KEY, m ? "1" : "0");

const audio = () => {
  if (isMuted()) return null;
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    return ctx;
  } catch { return null; }
};

function tone(c, { f = 440, t = 0, d = 0.1, type = "sine", v = 0.2, to }) {
  const o = c.createOscillator();
  const g = c.createGain();
  const s = c.currentTime + t;
  o.type = type;
  o.frequency.setValueAtTime(f, s);
  if (to) o.frequency.exponentialRampToValueAtTime(to, s + d);
  g.gain.setValueAtTime(0.0001, s);
  g.gain.exponentialRampToValueAtTime(v, s + 0.006);
  g.gain.exponentialRampToValueAtTime(0.0001, s + d);
  o.connect(g).connect(c.destination);
  o.start(s);
  o.stop(s + d + 0.03);
}

const play = (fn) => { const c = audio(); if (c) fn(c); };
const ticks = (c, dur, from = 0) => { let t = from; let gap = 0.03; while (t < from + dur) { tone(c, { f: 1500 - (t - from) * 300, t, d: 0.022, type: "square", v: 0.045 }); t += gap; gap *= 1.06; } };
const clunk = (c, t) => { tone(c, { f: 160, t, d: 0.14, type: "triangle", v: 0.3, to: 90 }); tone(c, { f: 1200, t, d: 0.04, type: "square", v: 0.05 }); };
const coin = (c, t = 0, v = 0.07) => { tone(c, { f: 988, t, d: 0.07, type: "square", v }); tone(c, { f: 1319, t: t + 0.07, d: 0.32, type: "square", v }); };

const BANK = [
  (c) => coin(c),
  (c) => { coin(c, 0); coin(c, 0.12, 0.06); },
  (c) => { for (let i = 0; i < 7; i++) tone(c, { f: 1100 + Math.random() * 700, t: i * 0.045, d: 0.06, type: "square", v: 0.04 }); },
  (c) => { tone(c, { f: 2093, d: 0.05, type: "square", v: 0.05 }); tone(c, { f: 1568, t: 0.06, d: 0.45, v: 0.15 }); tone(c, { f: 2637, t: 0.06, d: 0.45, v: 0.07 }); },
  (c) => [1319, 1760].forEach((f, i) => tone(c, { f, t: i * 0.1, d: 0.45, v: 0.12 })),
  (c) => [784, 988, 1175, 1568].forEach((f, i) => tone(c, { f, t: i * 0.06, d: 0.25, type: "triangle", v: 0.13 })),
  (c) => tone(c, { f: 300, d: 0.3, type: "square", v: 0.05, to: 1500 }),
  (c) => { clunk(c, 0); tone(c, { f: 1047, t: 0.05, d: 0.22, v: 0.1 }); },
  (c) => [1568, 1319, 1568, 2093].forEach((f, i) => tone(c, { f, t: i * 0.05, d: 0.12, type: "square", v: 0.045 })),
];
let last = -1;

export const sfx = {
  tick: () => play((c) => tone(c, { f: 1700, d: 0.03, type: "square", v: 0.05 })),
  reel: () => play((c) => { ticks(c, 0.42); clunk(c, 0.45); tone(c, { f: 880, t: 0.47, d: 0.2, v: 0.1 }); }),
  coin: () => play((c) => coin(c)),
  pick: () => play((c) => { let i = last; while (i === last) i = Math.floor(Math.random() * BANK.length); last = i; BANK[i](c); }),
  rain: () => play((c) => { for (let i = 0; i < 12; i++) coin(c, i * 0.08 + Math.random() * 0.04, 0.04); }),
  ding: () => play((c) => [1047, 1568, 2093].forEach((f, i) => tone(c, { f, t: i * 0.12, d: 0.55, v: 0.15 }))),
  buzz: () => play((c) => { tone(c, { f: 140, d: 0.18, type: "sawtooth", v: 0.07 }); tone(c, { f: 110, t: 0.2, d: 0.25, type: "sawtooth", v: 0.07 }); }),
  jackpot: () => play((c) => {
    ticks(c, 1.5);
    [0.9, 1.2, 1.5].forEach((t) => clunk(c, t));
    [523, 659, 784, 1047, 784, 1047, 1319, 1568].forEach((f, i) => tone(c, { f, t: 1.7 + i * 0.09, d: 0.22, type: "square", v: 0.07 }));
    tone(c, { f: 2093, t: 2.45, d: 0.7, v: 0.14 });
    for (let i = 0; i < 18; i++) coin(c, 2.0 + i * 0.09 + Math.random() * 0.05, 0.045);
  }),
  nearMiss: () => play((c) => {
    ticks(c, 1.5);
    [0.9, 1.2, 1.5].forEach((t) => clunk(c, t));
    tone(c, { f: 440, t: 1.7, d: 0.3, type: "triangle", v: 0.15 });
    tone(c, { f: 330, t: 2.0, d: 0.5, type: "triangle", v: 0.15, to: 260 });
  }),
};
